import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CategoryNavigationComponent, CmsComponentData, NavigationNode, NavigationService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { CmsNavigationComponent, WindowRef } from '@spartacus/core';
import { CustomNavigationService } from '../custom-navigation.service';
import { ICON_TYPE } from '../../../../../../custom/icons/icon.model';

@Component({
  selector: 'cx-category-navigation',
  templateUrl: './custom-category-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomCategoryNavigationComponent extends CategoryNavigationComponent {
  iconTypes = ICON_TYPE;

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService,
    protected customService: CustomNavigationService,
    protected winRef: WindowRef,
  ) {
    super(componentData, service);
  }

  node$: Observable<NavigationNode> = this.customService.getNavigationNode(
    this.componentData.data$
  );

  closeMenuMobile(): void {
    this.winRef.document.getElementById('burger-icon').click();
  }
}
